<template>
    <mc-input
        v-model="innerValue"
        class="ingredient-textarea"
        type="textarea"
        :disabled="disabled"
    />
</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api';

export default {
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance();

        const innerValue = computed({
            get() {
                return props.value.join(',');
            },
            set(val) {
                proxy.$emit('input', val.split(','));
            },
        });

        return {
            innerValue,
        };
    },
};
</script>

<style lang="scss" scoped>
.ingredient-textarea{
    ::v-deep .mtd-textarea {
        width: 700px;
    }
}
</style>
